var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary-text-btn ml-4"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handelPrimaryBtn}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }